import * as mentorApi from '../../api/mentorApi';
import { entityKey } from '../ids';
import { titleCaseWord } from './helpers';

/**
 * Canonical session entity for workspace store (mentorApi.normalizeSession shape).
 */
export function normalizeSessionEntity(session) {
  if (!session) return null;
  const base = mentorApi.normalizeSession(session);
  if (!base) return null;

  return {
    ...base,
    id: entityKey(base.id),
    cohortId: entityKey(base.cohortId),
    groupId: base.groupId ? entityKey(base.groupId) : '',
    schoolId: entityKey(base.schoolId),
    branchId: base.branchId ? entityKey(base.branchId) : '',
    sessionNumber: Number(base.sessionNumber || 0),
    scheduledAt: base.scheduledAt || '',
    timeSlot: base.timeSlot || '',
    meetingLink: base.meetingLink || '',
    comments: base.comments || '',
    resources: Array.isArray(base.resources) ? base.resources.map(String) : [],
    auditorAssignments: Array.isArray(base.auditorAssignments)
      ? base.auditorAssignments.map(a => ({
          ...a,
          id: entityKey(a.id),
          auditorId: entityKey(a.auditorId),
          roomNumber: a.roomNumber ?? null,
          assignmentStatus: a.assignmentStatus || 'pending',
        }))
      : [],
    auditors: [...new Set(
      Array.isArray(base.auditors)
        ? base.auditors.map(String)
        : (Array.isArray(base.auditorAssignments)
          ? base.auditorAssignments.map(a => String(a.auditorId || ''))
          : [])
    )].filter(Boolean),
    status: titleCaseWord(base.status) || 'Planned',
  };
}